import { Component, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

// This file is part of the entry, which every build ships. It must stay free of router code, so it
// uses plain keys that the locale files carry (the same texts as the trade copy table).
const Failed = ({ onRetry }: { onRetry: () => void }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div
        role="alert"
        className="mx-2 mb-2 rounded-lg bg-amber-500/10 px-3 py-2 text-center text-xs text-amber-600 dark:text-amber-400"
      >
        {t('trade-err-unavailable', 'Trading is not available for this market right now. Please try again later.')}
      </div>
      <button
        type="button"
        className="mx-2 mb-2 w-[calc(100%-1rem)] rounded-lg border border-foreground/20 px-3 py-2 text-sm"
        onClick={onRetry}
      >
        {t('trade-retry', 'Retry')}
      </button>
    </div>
  );
};

/**
 * Catches a failed load or a crash of the router trade view and shows the error in the panel, with a retry
 * button. It does not fall back to the direct path, and the error does not reach the page error boundary.
 */
export class RouterLoadBoundary extends Component<{ children: ReactNode; onRetry: () => void }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    return this.state.failed ? <Failed onRetry={this.props.onRetry} /> : this.props.children;
  }
}
